export default "__VITE_ASSET__C_p6JFwY__"